
import {LOGIN_TYPE_KEY, MSUITE_LOCAL_KEY} from '@/constant/login';
import Vue from 'vue'
import msDataProvider from "../services/msDataProvider";
import LocalStorage from "@/services/localStorage";

export default Vue.extend({
  props: ["value", "options", "isConfirmPassword"],
  data() {
    return {
      dialog: false,
      val: this.value,
      valid: true,
      required: (value, label) => !!value || (label || '') + ' ' + this.$t("USERNAME_PASSWORD.REQUIRED"),
      password: '',
      showPwd: false,
      loginType: "",
      passwordErr: '',
      loading: false,
      currentServerName: ""
    }
  },
  watch: {
    value(val) {
      this.passwordErr = "";
      this.val = val;
    }
  },
  methods: {
    onPasswordInputChange() {
      this.passwordErr = "";
    },
    close() {
      this.$refs.form.reset();
      this.val = false;
      if (typeof this.options.closeCallBack === 'function') {
        this.options.closeCallBack();
      }
      this.$emit('input', false);
      this.$emit('no');
    },
    async eventHandler(command, params) {
      if (!params) {
        params = {}
      }
      if (command) {
        await msDataProvider.executeCommand(command, params);
        this.$router.push("/prepare").catch((e) => e);
      }
      this.dialog = false
    },
    handleSubmit() {
      return;
    },
    async confirmYes() {
      if (this.isConfirmPassword) {
        const loginTypeList = LocalStorage.getItem(LOGIN_TYPE_KEY);
        if (loginTypeList) {
          this.loginType = loginTypeList[this.currentServerName] || MSUITE_LOCAL_KEY;
        } else {
          this.loginType = MSUITE_LOCAL_KEY;
        }
        try {
          this.loading = true;
          const response = await msDataProvider.executeCommand("confirmPassword", {
            password: this.password,
            provider_name: this.loginType
          });
          if (response.error_code === 1) {
            this.passwordErr = this.$t("USERNAME_PASSWORD.PASSWORD_INCORRECT");
            return;
          }
          if (response.error_code) {
            this.passwordErr = response.message;
            return;
          }
          if (response.error) {
            this.passwordErr = response.error;
            return;
          }
        } catch (e) {
          this.passwordErr = e;
        } finally {
          this.loading = false;
          this.$refs.form.reset();
        }
      }
      this.$emit('ok', () => {
        this.$refs.form.reset();
      });
    },
    confirmNo() {
      this.$refs.form.reset();
      this.$emit('no');
    }
  },
  async created() {
    if (this.isConfirmPassword) {
      try {
        this.currentServerName = await msDataProvider.executeCommand(
            "backendServerNameGetCurrentValue"
        );
      } catch (e) {
        this.error = e;
      }
    }
  }
})
